import { useLocation } from 'react-router';

export default (params) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return query.getAll(params);
};
